import React from 'react';
import dynamic from 'next/dynamic';
import { DesktopNav } from '../NavMenu/Desktop';
import { Container, SubContainer } from '../styles';

/**
 * We dynamically import these components so they are not chunking up the main bundle.
 * This helps it put in separate chunks which can be loaded in parallel by the browser.
 * This is a good way to improve performance.
 *
 * Important is we need to set SSR to TRUE so that these components are rendered on the server
 * allowing us to ship the HTML structure that is generated on the server.
 */
const SearchBar = dynamic(() => import('@components/SearchBar').then(mod => mod.SearchBar), {
  ssr: true,
});

export const DesktopHeader = () => {
  return (
    <Container>
      <SubContainer>
        <SearchBar />
      </SubContainer>
      <DesktopNav />
    </Container>
  );
};
